import axios from 'axios'

const adminApi = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
})

let refreshPromise = null

async function refreshSession() {
    if (!refreshPromise) {
        refreshPromise = adminApi.post('/api/admin/refresh', null, {
            skipAuthRefresh: true,
        }).finally(() => {
            refreshPromise = null
        })
    }

    return refreshPromise
}

adminApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config
        const status = error.response?.status

        if (
            status !== 401 ||
            originalRequest?._retry ||
            originalRequest?.skipAuthRefresh ||
            originalRequest?.url?.includes('/api/admin/login')
        ) {
            throw error
        }

        originalRequest._retry = true
        await refreshSession()

        return adminApi(originalRequest)
    }
)

export default adminApi
